import Image, { ImageProps } from 'next/image';
import { JSX } from 'react/jsx-dev-runtime';

import { cn } from '@videoblocks/design-system';

export interface AiToolkitImagePreviewProps extends ImageProps {
    containerClassName?: string;
}

export const AiToolkitImagePreview = ({ containerClassName, ...props }: AiToolkitImagePreviewProps): JSX.Element => {
    return (
        <div
            className={cn(
                'w-full aspect-video relative bg-black rounded-sm border border-white/20 overflow-hidden',
                containerClassName,
            )}
        >
            <Image
                fill
                className="object-contain"
                sizes="(max-width: 768px) 100vw, (max-width: 1024px) 60vw, 50vw"
                {...props}
            />
        </div>
    );
};
